import {Component, Input, OnInit} from "@angular/core";
import {DbActiveModal} from "../../../../../modules/modal/modal-ref";
import {GoogleAnalyticsService} from "../../../../../shared/services/google-analytics/google-analytics.service";

@Component({
    selector: 'db-webp-via-server-dialog',
    templateUrl: './webp-via-server-dialog.component.html',
    styleUrls: ['./webp-via-server-dialog.component.scss'],
    standalone: false
})
export class WebPViaServerDialogComponent implements OnInit {

  @Input() serverType: string;
  public isCopiedBeforeServerCode: boolean = false;
  public isCopiedInsideServerCode: boolean = false;
  public isCopiedApacheServerCode: boolean = false;
  public isMobile: boolean;
  public apacheServer: boolean;
  public codeBeforeServerDirective: string =
    "map $http_accept $webp_suffix {\n" +
    "    default \"\";\n" +
    "    \"~*webp\" \".webp\";\n" +
    "}";

  public codeInsideServerDirective: string =
    "location ~* ^.+\\.(png|jpe?g)$ {\n" +
    "    add_header Vary Accept;\n" +
    "    try_files $uri$webp_suffix $uri =404;\n" +
    "}";

  public codeApacheServerDirective: string =
    "<IfModule mod_rewrite.c>\n" +
    "  RewriteEngine On\n" +
    "\n" +
    "  # Does browser explicitly support webp?\n" +
    "  RewriteCond %{HTTP_USER_AGENT} Chrome [OR]\n" +
    "  # OR Is request from Page Speed\n" +
    "  RewriteCond %{HTTP_USER_AGENT} \"Google Page Speed Insights\" [OR]\n" +
    "  # OR does this browser explicitly support webp\n" +
    "  RewriteCond %{HTTP_ACCEPT} image/webp\n" +
    "  # AND NOT MS EDGE 42/17 - doesnt work.\n" +
    "  RewriteCond %{HTTP_USER_AGENT} !Edge/17\n" +
    "  # AND is the request a jpg, png or gif?\n" +
    "  RewriteCond %{REQUEST_URI} ^(.+)\\.(?:jpe?g|png|gif)$\n" +
    "  # AND does a .ext.webp image exist?\n" +
    "  RewriteCond %{DOCUMENT_ROOT}%{REQUEST_URI}.webp -f\n" +
    "  # THEN send the webp image and set the env var webp\n" +
    "  RewriteRule ^(.+)$ $1.webp [NC,T=image/webp,E=webp,L]\n" +
    "</IfModule>\n" +
    "\n" +
    "<IfModule mod_headers.c>\n" +
    "  # If REDIRECT_webp env var exists, append Accept to the Vary header\n" +
    "  Header append Vary Accept env=REDIRECT_webp\n" +
    "</IfModule>\n" +
    "\n" +
    "<IfModule mod_mime.c>\n" +
    "  AddType image/webp .webp\n" +
    "</IfModule>";

  constructor(
    private _activeModal: DbActiveModal,
    private _googleAnalyticsService: GoogleAnalyticsService,
  ) {}

  ngOnInit() {
    this.isMobile = window.innerWidth <= 991;
    const serverType = this.serverType.toLowerCase();
    this.apacheServer = serverType.includes('apache');
    this.resize([null, 700]);
  }

  public resize(size: [number, number]): void {
    this._activeModal.resize(...size);
  }

}
